import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import axios from "axios";

import { createApp } from "vue";

import { Luminous, LuminousGallery } from "luminous-lightbox";
import "luminous-lightbox/dist/luminous-basic.min.css";

import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.css";

import Quill from "quill";
import "quill/dist/quill.snow.css";

import "@fortawesome/fontawesome-free/css/all.css";

import SectionGeneralMasters from "./components/general_masters.vue";
if (document.getElementById("SectionGeneralMasters")) {
    createApp(SectionGeneralMasters).mount("#SectionGeneralMasters");
}

import SectionSuppliers from "./components/suppliers.vue";
if (document.getElementById("SectionSuppliers")) {
    createApp(SectionSuppliers).mount("#SectionSuppliers");
}

import SectionImageMulti from "./components/image_multi.vue";
document.querySelectorAll('[data-type="image-multi"]').forEach((element) => {
    createApp(SectionImageMulti).mount(element);
});

import SectionImageTemplate from "./components/image_template.vue";
document.querySelectorAll('[data-type="image-template"]').forEach((element) => {
    createApp(SectionImageTemplate).mount(element);
});

import SectionSetProductDetail from "./components/set_product_detail.vue";
document
    .querySelectorAll('[data-type="set-product-detail"]')
    .forEach((element) => {
        createApp(SectionSetProductDetail).mount(element);
    });

import SectionProductItemRelations from "./components/product_item_relations.vue";
document
    .querySelectorAll('[data-type="product-item-relations"]')
    .forEach((element) => {
        createApp(SectionProductItemRelations, {
            name: element.dataset.name,
            initialItems: JSON.parse(element.dataset.items || "[]"),
        }).mount(element);
    });

document.addEventListener("DOMContentLoaded", () => {
    const token = document.getElementById("CsrfToken").content;
    const overlay = document.getElementById("Overlay");

    // デフォルトドラッグ・ドロップの挙動を抑止
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
        document.body.addEventListener(eventName, (e) => e.preventDefault());
    });

    //項目が変更された場合にリロードをかける
    document
        .querySelectorAll('[data-type="change-reload"]')
        .forEach((element) => {
            element.addEventListener("change", (event) => {
                const form = document.getElementById("MainForm");
                form.setAttribute("action", form.action + "?reload=true");
                form.submit();
            });
        });

    //画像popup
    new LuminousGallery(document.querySelectorAll("[data-type=image-gallery]"));

    //アカウントメニューOpen
    const accountMenuButton = document.getElementById("AccountMenuButton");
    const accountMenu = document.getElementById("AccountMenu");
    if (accountMenuButton !== null && accountMenu !== null) {
        accountMenuButton.addEventListener("click", function (event) {
            if (!accountMenu.classList.contains("open")) {
                accountMenu.classList.add("open");
                overlay.classList.add("open");
            } else {
                accountMenu.classList.remove("open");
            }
        });
    }

    //スマホメニューOpen
    const spMenuButton = document.getElementById("SPMenuButton");
    const nav = document.getElementById("Nav");
    if (spMenuButton !== null && nav !== null) {
        spMenuButton.addEventListener("click", function (event) {
            if (!nav.classList.contains("open")) {
                nav.classList.add("open");
                overlay.classList.add("open");
            } else {
                nav.classList.remove("open");
            }
        });
    }

    //一覧メニューOpen
    const indexMenuButton = document.getElementById("IndexMenuButton");
    const indexMenuList = document.getElementById("IndexMenuList");
    if (indexMenuButton !== null && indexMenuList !== null) {
        indexMenuButton.addEventListener("click", function (event) {
            if (!indexMenuList.classList.contains("open")) {
                indexMenuList.classList.add("open");
                overlay.classList.add("open");
            } else {
                indexMenuList.classList.remove("open");
                overlay.classList.remove("open");
            }
        });

        indexMenuList.addEventListener("click", () => {
            indexMenuList.classList.remove("open");
            overlay.classList.remove("open");
        });
    }

    //オーバーレイクリックでClose
    if (overlay !== null) {
        overlay.addEventListener("click", function (event) {
            if (
                accountMenu !== null &&
                accountMenu.classList.contains("open")
            ) {
                accountMenu.classList.remove("open");
            }
            if (nav !== null && nav.classList.contains("open")) {
                nav.classList.remove("open");
            }
            if (
                indexMenuList !== null &&
                indexMenuList.classList.contains("open")
            ) {
                indexMenuList.classList.remove("open");
            }

            overlay.classList.remove("open");
        });
    }

    //一覧検索パネル
    const openSearchPanel = document.getElementById("OpenSearchPanel");
    const searchWrapper = document.getElementById("SearchWrapper");
    if (openSearchPanel != null && searchWrapper != null) {
        //検索パネルOpen
        openSearchPanel.addEventListener("click", function (event) {
            searchWrapper.classList.add("open");
        });

        //検索オーバーレイクリックでClose
        searchWrapper.addEventListener("click", function (event) {
            if (event.target.id == "SearchWrapper") {
                searchWrapper.classList.remove("open");
            }
        });
    }

    //検索条件反映
    let searchConditionDic = [];
    document.querySelectorAll("[data-search-code]").forEach((element) => {
        searchConditionDic[element.dataset.searchCode] = element.innerText;
        searchConditionDic[element.dataset.searchCode + "_from"] =
            element.innerText + "(開始)";
        searchConditionDic[element.dataset.searchCode + "_to"] =
            element.innerText + "(終了)";
    });
    document.querySelectorAll("[data-search-name]").forEach((element) => {
        element.innerText = searchConditionDic[element.innerText];
    });
    document.querySelectorAll("[data-search-value]").forEach((element) => {
        const code = element.dataset.searchValue;

        document
            .querySelectorAll("[name=" + code + "] option")
            .forEach((optionElement) => {
                if (element.innerText == optionElement.value) {
                    element.innerText = optionElement.innerText;
                }
            });
    });

    //検索処理メソッド
    const execSearch = (event) => {
        let params = "";
        document
            .querySelectorAll("#Search input,#Search select")
            .forEach((inputElement) => {
                if (inputElement.type == "submit") return;

                if (inputElement.type == "radio" && !inputElement.checked)
                    return;
                if (inputElement.type == "checkbox" && !inputElement.checked)
                    return;

                let name = inputElement.name ?? "";
                let value = inputElement.value ?? "";

                if (name != "" && value != "") {
                    params += params == "" ? "" : "&";
                    params += name + "=" + encodeURI(value);
                }
            });

        window.location.href = location.pathname + "?" + params;
    };

    //検索実行
    document
        .querySelectorAll("[data-type=search-button]")
        .forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                execSearch(event);
            });
        });

    //form action切替
    document.querySelectorAll("[type=submit]").forEach((element) => {
        if (element.dataset.action != undefined) {
            element.addEventListener("click", (event) => {
                if (element.dataset.target != undefined) {
                    element.closest("form").target = element.dataset.target;
                }

                element.closest("form").action = element.dataset.action;
            });
        }
    });

    //Enter押下時、フォーカスされている要素がinputかselectだったらsubmit
    window.document.onkeydown = function (event) {
        if (event.key === "Enter" && !event.isComposing) {
            if (
                document.activeElement.tagName == "INPUT" ||
                document.activeElement.tagName == "SELECT"
            ) {
                if (document.activeElement.closest("#Search")) {
                    //検索ウインドウ内の項目なら検索実行
                    event.preventDefault();
                    execSearch(event);
                } else if (
                    document.activeElement.closest("form").id == "MainForm"
                ) {
                    //MainForm内の項目ならSubmit
                    event.preventDefault();
                    document.activeElement.closest("form").submit();
                }
            }
        }
    };

    //アラートClose
    document.querySelectorAll('[data-type="alert"]').forEach((element) => {
        element.addEventListener("click", function (event) {
            element.classList.add("close");
        });
    });

    //DatePickerカレンダー
    document.querySelectorAll('[data-type="calendar"]').forEach((element) => {
        let options = { locale: "ja", disableMobile: true };

        if (element.dataset.mindate) {
            options["minDate"] = element.dataset.mindate;
        }

        flatpickr(element, options);
    });

    //DateTime項目
    document.querySelectorAll("[data-type=datetime]").forEach((element) => {
        element
            .querySelectorAll("input[type=text], select")
            .forEach((inputElement) => {
                inputElement.addEventListener("change", (event) => {
                    let date = element.querySelector("input[type=text]").value;
                    let time = element.querySelector("select").value;

                    if (date !== "") {
                        element.querySelector("input[type=hidden]").value =
                            date + " " + time;
                    } else {
                        element.querySelector("input[type=hidden]").value = "";
                    }
                });
            });
    });

    //画像アップロード
    document
        .querySelectorAll('[data-type="upload-image"]')
        .forEach((element) => {
            const dropArea = element.nextElementSibling;

            // ハイライト処理
            ["dragenter", "dragover"].forEach((eventName) => {
                dropArea.addEventListener(eventName, () =>
                    dropArea.classList.add("highlight"),
                );
            });
            ["dragleave", "drop"].forEach((eventName) => {
                dropArea.addEventListener(eventName, () =>
                    dropArea.classList.remove("highlight"),
                );
            });

            element.addEventListener("click", (event) => {
                element.value = "";
            });

            dropArea.addEventListener("drop", (event) => {
                const file = event.dataTransfer.files[0];
                handleFiles(file);
            });

            element.addEventListener("change", (event) => {
                const file = element.files[0];
                handleFiles(file);
            });

            function handleFiles(file) {
                let formData = new FormData();
                formData.append("upfile", file);
                formData.append("_token", token);

                axios
                    .post("/file/upload_image", formData)
                    .then((response) => {
                        if (response.data.status == "OK") {
                            const wrapper = element.closest(".input-image");
                            wrapper.querySelector("input[type=hidden]").value =
                                response.data.url;
                            wrapper.querySelector("img").src =
                                response.data.url;
                            wrapper.querySelector(
                                ".input-image--thumbnail",
                            ).style.display = "flex";
                        } else {
                            alert(
                                response.data.message ??
                                    "アップロードに失敗しました",
                            );
                        }
                    })
                    .catch((error) => {
                        alert("アップロードに失敗しました");
                    });
            }
        });

    //アップロード画像キャンセル
    document
        .querySelectorAll('[data-type="upload-image-cancel"]')
        .forEach((element) => {
            element.addEventListener("click", (event) => {
                const wrapper = element.closest(".input-image");
                wrapper.querySelector("input[type=hidden]").value = "";
                wrapper.querySelector("img").src = "";
                wrapper.querySelector(".input-image--thumbnail").style.display =
                    "none";
            });
        });

    //ラベル区分色設定
    document.querySelectorAll('[data-type="label-div"]').forEach((element) => {
        element.addEventListener("change", (event) => {
            element.classList.remove(...element.classList);

            if (element.value == 1) {
                element.classList.add("edit__label-div--primary");
            }
            if (element.value == 2) {
                element.classList.add("edit__label-div--success");
            }
            if (element.value == 3) {
                element.classList.add("edit__label-div--info");
            }
            if (element.value == 4) {
                element.classList.add("edit__label-div--warning");
            }
            if (element.value == 5) {
                element.classList.add("edit__label-div--danger");
            }
        });

        element.dispatchEvent(new Event("change"));
    });

    //確認モーダル
    const modalConfirm = document.getElementById("ModalConfirm");
    if (modalConfirm !== null) {
        document
            .querySelectorAll('[data-type="confirm"],[data-type="download"]')
            .forEach((element) => {
                element.addEventListener("click", (event) => {
                    event.preventDefault();

                    modalConfirm.classList.add("open");

                    const modalConfirmMessage =
                        document.getElementById("ModalMessage");
                    modalConfirmMessage.innerText = element.dataset.message;

                    if (element.dataset.action != undefined) {
                        element.closest("form").action = element.dataset.action;
                    }
                });
            });

        //確認モーダルオーバーレイクリックでClose
        modalConfirm.addEventListener("click", function (event) {
            if (event.target.id == "ModalConfirm") {
                modalConfirm.classList.remove("open");
            }
        });

        //確認モーダルキャンセルClick
        const modalCancel = document.getElementById("ModalCancel");
        modalCancel.addEventListener("click", (event) => {
            event.preventDefault();
            modalConfirm.classList.remove("open");
            modalConfirm.closest("form").action = "";
        });

        //確認モーダル実行Click
        const modalSubmit = document.getElementById("ModalSubmit");
        modalSubmit.addEventListener("click", (event) => {
            modalConfirm.classList.remove("open");
        });
    }

    //iframeモーダル
    const modalIframe = document.getElementById("ModalIframe");
    if (modalIframe !== null) {
        document
            .querySelectorAll('[data-type="iframe-modal"]')
            .forEach((element) => {
                element.addEventListener("click", (event) => {
                    event.preventDefault();

                    if (element.dataset.idlistQuery !== undefined) {
                        let idList = [];
                        document
                            .querySelectorAll('[name="checked_data[]"')
                            .forEach((checkboxElement) => {
                                if (checkboxElement.checked) {
                                    idList.push(checkboxElement.value);
                                }
                            });

                        if (idList.length == 0) {
                            alert("データが選択されていません");
                            return;
                        }

                        if (element.dataset.href.includes("?")) {
                            element.dataset.href =
                                element.dataset.href +
                                "&id_list=" +
                                idList.join(",");
                        } else {
                            element.dataset.href =
                                element.dataset.href +
                                "?id_list=" +
                                idList.join(",");
                        }
                    }

                    modalIframe.classList.add("open");
                    const iframe = modalIframe.querySelector("iframe");
                    iframe.src = element.dataset.href;
                });
            });

        //iframeモーダルオーバーレイクリックでClose
        modalIframe.addEventListener("click", function (event) {
            if (event.target.id == "ModalIframe") {
                modalIframe.classList.remove("open");
            }
        });
    }

    //一覧のすべてチェック
    const indexCheckAll = document.querySelector("[data-type=index-check-all]");
    if (indexCheckAll !== null) {
        indexCheckAll.addEventListener("click", (event) => {
            document
                .querySelectorAll("[data-type=index-check-item]")
                .forEach((element) => {
                    element.checked = indexCheckAll.checked;
                });
        });
    }

    //メニューロールのselect
    document
        .querySelectorAll("[data-type=select-role-div]")
        .forEach((element) => {
            element.addEventListener("change", (event) => {
                element.classList.remove(...element.classList);

                if (element.value == 0) {
                    element.classList.add("role-div--disable");
                } else if (element.value == 1) {
                    element.classList.add("role-div--enable");
                } else if (element.value == 2) {
                    element.classList.add("role-div--readonly");
                }
            });
            element.dispatchEvent(new Event("change"));
        });

    //Quill(WYSIWYGエディタ)
    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["link", "image"],
        ["clean"],
    ];
    document.querySelectorAll("[data-type=wysiwyg]").forEach((element) => {
        let quill = new Quill(element, {
            modules: { toolbar: toolbarOptions },
            theme: "snow",
        });
        quill.on("editor-change", function (delta, oldDelta, source) {
            document.getElementById(element.dataset.target).value =
                quill.root.innerHTML;
        });
    });

    //サマリーテーブルの幅調整
    document.querySelectorAll(".index__summary-table").forEach((element) => {
        window.addEventListener("resize", () => {
            let width = element.dataset.width;
            let outerWidth = element.parentElement.clientWidth - 15;

            if (outerWidth > width) {
                element.style.width = outerWidth + "px";
            } else {
                element.style.width = element.dataset.width + "px";
            }

            element.parentElement.style.maxHeight =
                "calc(100vh - " + element.dataset.offsetHeight + "px)";
        });
        window.dispatchEvent(new Event("resize"));
    });

    //汎用検索ドロップダウン変更
    document.querySelectorAll("#GenericConfigID").forEach((element) => {
        element.addEventListener("change", () => {
            location.href = "/generic_search/" + element.value;
        });
    });

    //バリデーション表示
    if (window.errors != null) {
        Object.keys(window.errors).forEach((key) => {
            const validationTarget = document.querySelector(
                '[data-validation="' + key + '"]',
            );
            if (validationTarget) {
                validationTarget.classList.add("is-invalid");
                validationTarget.insertAdjacentHTML(
                    "afterend",
                    '<div class="invalid-feedback">' +
                        window.errors[key][0] +
                        "</div>",
                );
            }
        });
    }

    document.querySelectorAll("[data-type=ajax-select]").forEach((element) => {
        const table = element.dataset.table;
        const code = element.dataset.code || "code";
        const name = element.dataset.name || "name";
        const id = element.dataset.id || false;

        const ts = new TomSelect(element, {
            valueField: "id",
            labelField: "name",
            searchField: "name",
            load: function (query, callback) {
                if (!query.length) return callback();

                fetch(
                    "/search_api/" +
                        table +
                        "/" +
                        code +
                        "/" +
                        name +
                        "?q=" +
                        encodeURIComponent(query),
                )
                    .then((response) => response.json())
                    .then((json) => {
                        callback(json);
                    })
                    .catch(() => {
                        callback();
                    });
            },
            create: false,
            maxOptions: 10,
        });

        if (id) {
            fetch(
                "/search_api/" + table + "/" + code + "/" + name + "?id=" + id,
            )
                .then((res) => res.json())
                .then((dataList) => {
                    const data = dataList[0] ?? null;
                    if (!data) return;

                    ts.addOption(data);
                    ts.setValue(data.id);
                });
        }
    });

    document
        .querySelectorAll("[data-type=ajax-select-kgms-sku]")
        .forEach((element) => {
            const ts = new TomSelect(element, {
                valueField: "id",
                labelField: "name",
                searchField: "name",
                load: function (query, callback) {
                    if (!query.length) return callback();

                    fetch(
                        "/issue_tool/search_sku" +
                            "?q=" +
                            encodeURIComponent(query),
                    )
                        .then((response) => response.json())
                        .then((json) => {
                            callback(json);
                        })
                        .catch(() => {
                            callback();
                        });
                },
                create: false,
                maxOptions: 10,
            });

            //Enterは候補の選択のみに使い、フォームをsubmitさせない
            ts.control_input.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        });
});
